// extracted by mini-css-extract-plugin
export default {"section":"About_section__08CZB","container":"About_container__WazHV","content":"About_content__aHwTY","title":"About_title__pZpnC","text":"About_text__q-vdH"};